import { ref } from 'vue'

/** Route name (e.g. Donations) set the moment a sidebar link is tapped, cleared when the page begins loading. */
const pendingRouteName = ref<string | null>(null)

export function consumeNavFeedback() {
  pendingRouteName.value = null
}

export function useDashboardNavFeedback() {
  const beginNavFeedback = (routeName: string) => {
    pendingRouteName.value = routeName
  }

  const isNavigating = () => pendingRouteName.value !== null

  return {
    pendingRouteName,
    beginNavFeedback,
    consumeNavFeedback,
    isNavigating,
  }
}
